// @ts-nocheck
const datadogLogger = require('@datadog/browser-logs');
const configurationManager = require('../config/configurationManager');
const stateManager = require('../state/stateManager');
const stringUtil = require('../string/stringUtil');


var ddLogger;
   

module.exports.initializeDatadog = function()
{
    if (ddLogger != null)
        return;

    if(stringUtil.isStringNullOrEmpty(configurationManager.getAppConfig().dataDogClientToken) || stringUtil.isStringNullOrEmpty(configurationManager.getAppConfig().dataDogSite))
        return;

    datadogLogger.datadogLogs.init({
        clientToken: configurationManager.getAppConfig().dataDogClientToken,
        site: configurationManager.getAppConfig().dataDogSite,
        env: getEnvironment(),
        service: "RMS.APP.CUSTOMER.WEB",
        version: configurationManager.getAppConfig().version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    });

    ddLogger = datadogLogger.datadogLogs.logger;
}

module.exports.resetGlobalContext = function()
{
    this.initializeDatadog();
    if (ddLogger == null)  return;

    datadogLogger.datadogLogs.setGlobalContext(
                                                { 
                                                    env: getEnvironment(),
                                                    applicationId: stateManager.getStore().getState().applicationId,
                                                    applicationTitle: stringUtil.sanitizeName(stateManager.getStore().getState().applicationTitle),
                                                    franchisorId: stateManager.getStore().getState().franchisor.id,
                                                    franchisorCode: stateManager.getStore().getState().franchisor.code,
                                                    franchisorName: stringUtil.sanitizeName(stateManager.getStore().getState().franchisor.name),
                                                    franchiseeId: stateManager.getStore().getState().franchisee.id,
                                                    franchiseeCode: stateManager.getStore().getState().franchisee.code,
                                                    franchiseeName: stringUtil.sanitizeName(stateManager.getStore().getState().franchisee.name),
                                                    propertyId: stateManager.getStore().getState().property.id,
                                                    propertyCode: stateManager.getStore().getState().property.code,
                                                    propertyName: stringUtil.sanitizeName(stateManager.getStore().getState().property.name),
                                                    tableNumber: stateManager.getStore().getState().tableNumber,
                                                    themeId: stateManager.getStore().getState().themeId,
                                                    venueCode: stateManager.getStore().getState().venueCode,
                                                    paymentLinkId: stateManager.getStore().getState().paymentLinkId,
                                                    currentMode: stateManager.getStore().getState().currentMode,
                                                });

    
}


module.exports.info = function(message, messageContext = {})
{
    try
    {
        messageContext = initializeMessageContext(messageContext);

        console.info(message);
        if (ddLogger != null) ddLogger.info(message, messageContext);
    }
    catch(error){}
}

module.exports.warn = function(message, messageContext = {})
{
    try
    {
        messageContext = initializeMessageContext(messageContext);

        console.warn(message);
        if (ddLogger != null) ddLogger.warn(message, messageContext);
    }
    catch(error){}
}

module.exports.error = function(message, messageContext, error)
{
    try
    {
        messageContext = initializeMessageContext(messageContext);
        
        console.error(message);
        if (ddLogger != null) ddLogger.error(message, messageContext, error)
    }
    catch(error){}
}

function initializeMessageContext(messageContext)
{
    if (messageContext == null)
        messageContext = {};

    messageContext.loggingDateTime = Date.now();
    messageContext.loggingType = "logging";
    return messageContext;
}

function getEnvironment()
{
    var env = configurationManager.getAppConfig().environment;
    if (stringUtil.areStringSame(env, "ukwest"))
        env = "production";
        
    return env;
}

